import { IGroupInfo } from '@/api/types/product';
import { setSession } from '@/utils/tools';
import { useSpmDomAttr, useSpmPosition } from '@/reporting/spm';
import { SearchOutlined } from '@zeelool/icon';
import Link from 'next/link';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export default function RelatedBlockLink({
  item,
  index,
  trackProductListPageRelatedGroupClick,
  trackProductListPageRelatedGroupExp,
  isWeb = false,
}: {
  item: IGroupInfo['related_block_link'][0];
  index: number;
  trackProductListPageRelatedGroupClick: (item: any, index: number, position: string) => void;
  trackProductListPageRelatedGroupExp: (item: any, index: number, position: string) => void;
  isWeb?: boolean;
}) {
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView) {
      trackProductListPageRelatedGroupExp(item, index, '底部相关导航位');
    }
  }, [inView]);

  // Data SPM DOM 打标（请求头 data-spm=1 开关）：category_entry_NN 仅 PC 编码表有
  // （与点击上报同表口径，2 位序号）；WAP 与无作用域复用查表不命中，零 DOM 差异。
  const getSpmPosition = useSpmPosition();
  const categoryEntryDomSpm = useSpmDomAttr(
    getSpmPosition(
      'related_categories_bottom',
      `category_entry_${String(index + 1).padStart(2, '0')}`,
    ),
  );

  return (
    <Link
      key={index}
      ref={ref}
      href={`/goods-list/${item.path || item.group_link}`}
      className={`
        flex items-center border  text-12 hover:bg-gray-50 transition-colors
        ${
          isWeb
            ? 'h-[32px] text-14 pr-16 pl-12 rounded-[20px] border-[#808080]'
            : 'pr-[13px] pl-[11px] h-[28px] border-primary-text rounded-[14px]'
        }
      `}
      onClick={() => {
        setSession('zl_goodsListEnterPageScene', '商品列表页底部相关导航位');
        trackProductListPageRelatedGroupClick(item, index, '底部相关导航位');
      }}
      {...categoryEntryDomSpm}
    >
      <SearchOutlined className="mr-[3px] text-primary-text text-[17px]" />
      <span className="text-primary-text max-w-[294px] truncate block">{item.link_name}</span>
    </Link>
  );
}
